export default __webpack_public_path__ + "static/media/gamedev.5f137c7e.png";